import { GameType } from '../shared/enume';

interface TeamInitialConfig {
  gameType?: string;
  teamA?: string;
  teamB?: string;
  teamC?: string;
}

export const pickTeamInitial = (
  name: string | undefined,
  avoid: Set<string> = new Set<string>(),
  skipD = false,
): string | undefined => {
  if (!name) return undefined;
  const upper = name.toUpperCase();

  let count = 0;
  for (let i = 0; i < upper.length && count < 4; i++) {
    const ch = upper[i];
    if (!/[A-Z]/.test(ch)) continue;
    count++;
    if (skipD && ch === 'D') continue;
    if (!avoid.has(ch)) return ch;
  }

  for (let i = 0; i < upper.length; i++) {
    const ch = upper[i];
    if (/[A-Z]/.test(ch)) return ch;
  }

  return undefined;
};

export const buildInitialToTeamMap = ({
  gameType,
  teamA,
  teamB,
  teamC,
}: TeamInitialConfig): Record<string, string> => {
  const map: Record<string, string> = {};
  const type = gameType?.toLowerCase();

  const addIf = (ch: string | undefined, teamName: string | undefined) => {
    if (!ch || !teamName) return;
    if (!map[ch]) map[ch] = teamName;
  };

  if (type === GameType.session) {
    return map;
  }

  if (type === GameType.test) {
    map.D = 'DRAW';
    const a = pickTeamInitial(teamA, new Set<string>(), true);
    const avoidForB = new Set<string>([...(a ? [a] : []), 'D']);
    const b = pickTeamInitial(teamB, avoidForB, true);
    const c = pickTeamInitial(
      teamC,
      new Set<string>([...(a ? [a] : []), ...(b ? [b] : []), 'D']),
      true,
    );
    addIf(a, teamA);
    addIf(b, teamB);
    addIf(c, teamC);
    return map;
  }

  const a = pickTeamInitial(teamA);
  const b = pickTeamInitial(teamB, new Set(a ? [a] : []));
  const c = pickTeamInitial(teamC, new Set([...(a ? [a] : []), ...(b ? [b] : [])]));
  addIf(a, teamA);
  addIf(b, teamB);
  addIf(c, teamC);
  return map;
};

export const buildValidFirstChars = ({
  gameType,
  teamA,
  teamB,
  teamC,
}: TeamInitialConfig): string[] => {
  const type = gameType?.toLowerCase();

  if (type === GameType.session) {
    return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  }

  if (type === GameType.test) {
    const a = pickTeamInitial(teamA, new Set<string>(), true);
    const avoidForB = new Set<string>([...(a ? [a] : []), 'D']);
    const b = pickTeamInitial(teamB, avoidForB, true);
    return [a, b, 'D'].filter(Boolean) as string[];
  }

  const a = pickTeamInitial(teamA);
  const b = pickTeamInitial(teamB, new Set(a ? [a] : []));
  const c = pickTeamInitial(teamC, new Set([...(a ? [a] : []), ...(b ? [b] : [])]));
  return [a, b, c].filter(Boolean) as string[];
};
